export const DEFAULT_CHANNEL = 'fronthub'
